import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subject, Observable } from 'rxjs';
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import {
  fetchAffiliate,
  getAffiliate,
} from "../../store/affiliate/affiliate.actions";
import { IState } from '@models/index';
import { HelperService } from '../helper/helper.service';
import { getAffiliateSelector, getAffiliatesSelector } from '@store/affiliate/affiliate.selectors';

@Injectable({
  providedIn: "root"
})
export class AffiliateService {
  backendUrl = environment.backendUrl;

  private _clickSaved = new Subject<boolean>();
  clickSaved$ = this._clickSaved.asObservable();

  constructor(
    private http: HttpClient,
    private store: Store<{ authToken: string }>
  ) {}


  getAffiliatesSelector(): Observable<IState> {
    return this.store.select(getAffiliatesSelector);
  }

  getAffiliateSelector(): Observable<any> {
    return this.store.select(getAffiliateSelector)
  }


  fetchAffiliates(filterOptions) {    
    this.store.dispatch(fetchAffiliate({ filterOptions }));
  }

  fetchAffiliate(id) {
    this.store.dispatch(getAffiliate({ id }))
  }

  fetchaffs(filterOptions) {
    this.store.dispatch(fetchAffiliate(filterOptions));
  }

  getAffiliates(page: number, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/users?${queryString}`); 
  }

  getAffiliate(id: string) {
    return this.http.get(`${this.backendUrl}/users/user/${id}`);
  }


}
